import {
  useCallback,
  useState,
} from 'react';

import { toast } from 'react-toastify';

import useConnectWallet from '@/store/wallet/useConnectWallet';

import useListenerTransfer from './useListenerTransfer';

const useRemoveLiquidity = (successFun?: Function, errorFun?: Function) => {
    const { address, contractEvm: { router } } = useConnectWallet()
    // 获取监听交易完成事件的函数
    const listenerTransferF = useListenerTransfer();
    const [removeLiquidityLod, setRemoveLiquidityLod] = useState(false)
    const removeLiquidity = useCallback(async (tokenA: string,
        tokenB: string,
        liquidity: BigInt,
        amountAMin: BigInt,
        amountBMin: BigInt,
        deadline: BigInt,
        toastText?: { success: string, error: string }
    ) => {
        if (router && tokenB && tokenA && deadline) {
            try {
                console.log(tokenA,
                    tokenB,
                    liquidity,
                    amountAMin,
                    amountBMin,
                    address,
                    deadline);

                setRemoveLiquidityLod(true); // 开始加载状态
                const { hash } = await router.removeLiquidity(
                    tokenA,
                    tokenB,
                    liquidity,
                    amountAMin,
                    amountBMin,
                    address,
                    deadline
                );
                // 监听交易完成事件
                const relset = await listenerTransferF(hash);

                if (relset) {
                    // 成功回调
                    toastText && toast.success(toastText.success);
                    successFun && successFun();
                } else {
                    // 失败回调
                    toastText && toast.error(toastText.error);
                    errorFun && errorFun();
                }
            } catch (error) {
                console.log('useRemoveLiquidity error:', error);
                toastText && toast.error(toastText.error);
            } finally {
                setRemoveLiquidityLod(false)
            }
        }
    }, [router, address, listenerTransferF, successFun, errorFun]);
    return {
        removeLiquidityLod,
        removeLiquidity
    }
}

export default useRemoveLiquidity